import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import Login from '@/views/Login.vue';
import Grades from '@/views/Grades.vue';
import Pricing from '@/views/Pricing.vue';
import Instructors from '@/views/Instructors.vue';
import OperatingHours from '@/views/OperatingHours.vue';
import InstructorsTimeSchedule from '@/views/InstructorsTimeSchedule.vue';
import Vouchers from "@/views/Vouchers.vue";
import Transactions from "@/views/Transactions.vue";
import store from "@/store/index";
import Analytics from "@/views/Analytics.vue";
import AdminBackup from "@/views/AdminBackup.vue";
import ActivityLog from "@/views/ActivityLog.vue";
import MultiPayout from "@/views/MultiPayout.vue";
import firebase from '@/plugins/firebase';
Vue.use(VueRouter);
// Promise that resolves when Firebase Auth state is initialized AND Vuex store is updated
let authReady = null;
function getAuthReady() {
    if (!authReady) {
        authReady = new Promise((resolve) => {
            const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
                unsubscribe();
                if (user) {
                    // Wait for the Vuex store to be updated with the user's role
                    // This happens in App.vue's onAuthStateChanged handler
                    // Poll until isLoggedIn becomes true (indicating store was updated)
                    const maxWait = 5000;
                    const startTime = Date.now();
                    while (!store.getters['user/isLoggedIn'] && Date.now() - startTime < maxWait) {
                        await new Promise(r => setTimeout(r, 50));
                    }
                }
                resolve();
            });
        });
    }
    return authReady;
}
const routes = [
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        strict: true
    },
    {
        path: '/other',
        name: 'Other',
        component: Dashboard,
    },
    {
        path: '/platove-tridy',
        name: 'Grades',
        component: Grades,
        meta: { requiresAuth: 'admin' },
    },
    {
        path: '/instruktori',
        name: 'Instructors',
        component: Instructors,
        meta: { requiresAuth: 'moderator' },
    },
    {
        path: '/provozni-doby',
        name: 'OperatingHours',
        component: OperatingHours,
        meta: { requiresAuth: 'admin' },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        strict: true,
    },
    {
        path: '/ceny',
        name: 'Pricing',
        component: Pricing,
        meta: { requiresAuth: 'admin' },
    },
    {
        path: '/rozpis-instruktoru',
        name: 'InstructorsTimeSchedule',
        component: InstructorsTimeSchedule,
    },
    {
        path: '/rozpis-instruktoru/:date',
        name: 'InstructorsTimeScheduleWithDate',
        component: InstructorsTimeSchedule,
    },
    {
        path: '/poukazy',
        name: 'Vouchers',
        component: Vouchers,
        meta: { requiresAuth: 'admin' },
    },
    {
        path: '/transakce',
        name: 'Transactions',
        component: Transactions,
        meta: { requiresAuth: 'moderator' },
    },
    {
        path: '/analytika',
        name: 'Analytics',
        component: Analytics,
        meta: { requiresAuth: 'moderator' },
    },
    {
        path: '/admin/zaloha',
        name: 'AdminBackup',
        component: AdminBackup,
        meta: { requiresAuth: 'admin' },
    },
    {
        path: '/activity-log',
        name: 'ActivityLog',
        component: ActivityLog,
        meta: { requiresAuth: 'admin' },
    },
    {
        path: '/hromadna-vyplata',
        name: 'MultiPayout',
        component: MultiPayout,
        meta: { requiresAuth: 'admin' },
    },
];
const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
});
router.beforeEach(async (to, from, next) => {
    // Wait for Firebase Auth to be ready before checking permissions
    if (to.matched.some(record => record.meta.requiresAuth)) {
        await getAuthReady();
    }
    if (to.matched.some(record => record.meta.requiresAuth === 'admin')) {
        store.getters['user/isAdmin'] ? next() : next({ name: 'Dashboard' });
    }
    else if (to.matched.some(record => record.meta.requiresAuth === 'moderator')) {
        store.getters['user/isModerator'] ? next() : next({ name: 'Dashboard' });
    }
    else {
        next();
    }
});
export default router;
